module.exports = __webpack_public_path__ + "static/media/loading.4e9a6136.gif";